/**
 * Bluespark Automotive logo — inline SVG so it renders crisply at any size
 * and adapts to white/dark themes via the `tone` prop.
 *
 * Anatomy: 6-point blue spark above the "Bluespark" wordmark, with
 * "AUTOMOTIVE" tagline beneath in tracked caps.
 */
const BluesparkLogo = ({
  tone = 'light',      // 'light' (white on dark) | 'dark' (dark on light)
  className = '',
  height = 40,
  showTagline = true,
}) => {
  const wordmarkColor = tone === 'light' ? '#FFFFFF' : '#0F172A';
  const sparkColor = '#2563EB'; // bluespark blue

  return (
    <svg
      viewBox="0 0 260 70"
      height={height}
      className={className}
      role="img"
      aria-label="Bluespark Automotive"
      data-testid="bluespark-logo"
    >
      {/* 6-point spark above the K */}
      <g transform="translate(186, 10)">
        <path
          fill={sparkColor}
          d="M14 0 L16.5 11 L28 14 L16.5 17 L14 28 L11.5 17 L0 14 L11.5 11 Z"
        />
        {/* small accent dot */}
        <circle cx="24" cy="4" r="2" fill={sparkColor} opacity="0.9" />
      </g>

      {/* Bluespark wordmark */}
      <text
        x="0"
        y="46"
        fontFamily="'Arial Black', 'Helvetica Neue', sans-serif"
        fontWeight="900"
        fontSize="38"
        letterSpacing="-1"
        fill={wordmarkColor}
      >
        Bluespark
      </text>

      {showTagline && (
        <text
          x="2"
          y="62"
          fontFamily="'Arial', sans-serif"
          fontWeight="600"
          fontSize="9"
          letterSpacing="3.5"
          fill={wordmarkColor}
        >
          AUTOMOTIVE
        </text>
      )}
    </svg>
  );
};

export default BluesparkLogo;
